import React, { createContext, useContext, useState } from 'react';
export type ReportSectionKey = 'signups' | 'revenue' | 'forecast' | 'health' | 'clubs';
export interface MonthlyClubReportSettings {
  enabled: boolean;
  /** "7:00 AM" */
  sendTime: string;
  recipients: string[];
  sections: Record<ReportSectionKey, boolean>;
}
interface ReportSettingsContextValue {
  settings: MonthlyClubReportSettings;
  saveSettings: (next: MonthlyClubReportSettings) => void;
}
const DEFAULT_SETTINGS: MonthlyClubReportSettings = {
  enabled: true,
  sendTime: '7:00 AM',
  recipients: ['owner@hillsideestate.com.au', 'clubmanager@hillsideestate.com.au'],
  sections: {
    signups: true,
    revenue: true,
    forecast: true,
    health: true,
    clubs: true
  }
};
const ReportSettingsContext = createContext<ReportSettingsContextValue | null>(null);
export function ReportSettingsProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [settings, setSettings] = useState<MonthlyClubReportSettings>(DEFAULT_SETTINGS);
  return <ReportSettingsContext.Provider value={{
    settings,
    saveSettings: setSettings
  }} data-id="element-6355" data-mp="1bgjxu8sumn7k">
      {children}
    </ReportSettingsContext.Provider>;
}
export function useReportSettings() {
  const context = useContext(ReportSettingsContext);
  if (!context) throw new Error('useReportSettings must be used within ReportSettingsProvider');
  return context;
}